// extracted by mini-css-extract-plugin
module.exports = {"videoBox":"PadiPromotion_videoBox__SVQTK","video":"PadiPromotion_video__40PQ5","imageBtn":"PadiPromotion_imageBtn__2Dee7"};